import React, { useState } from "react";
import axios from "axios";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  CircularProgress,
  Alert,
  FormHelperText,
} from "@mui/material";

import { VAVE, REASSIGNIL1SOURCING, REASSIGNIL1PD } from "../../AppConstant";
import { sourcingEmpIds } from "../switch_on_userlist";

// function AlertDialogForm({ setRefreshApi }) {
//   const sourcingReassignUsers = [
// { id: 1, empName: "Rajaram", empId: "300639" },
// { id: 2, empName: "Selva Sundaram", empId: "300197" },
//   ];
//   const [users, setUsers] = useState(sourcingReassignUsers);
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [success, setSuccess] = useState(null);

//   const handleSubmit = async () => {
//     if (!selectedUser) {
//       setError("Please select a user to reassign.");
//       return;
//     }

//     setLoading(true);
//     setError(null);
//     setSuccess(null);

//     const currentEmpId = localStorage.getItem("empid");

//     const formData = new FormData();

//     if (sourcingEmpIds.includes(currentEmpId)) {
//       formData.append("il1_sourcing_assigned_id", selectedUser.empId);
//       formData.append("il1_sourcing_assigned", selectedUser.empName);
//     } else {
//       formData.append("il1_pd_assigned_id", selectedUser);
//       formData.append("il1_pd_assigned", selectedUser);
//     }

//     try {
//       const url = sourcingEmpIds.includes(currentEmpId)
//         ? REASSIGNIL1SOURCING
//         : REASSIGNIL1PD;

//       await axios.post(VAVE, formData, {
//         headers: {
//           "Content-Type": "application/json",
//         },
//       });
//       alert("Submitted successfully!");

//       setRefreshApi(true);
//     } catch (error) {
//       console.error("Upload failed:", error);
//       alert("Upload failed. Please try again.");
//     } finally {
//       setRefreshApi(true);
//     }
//   };

//   return (
//     <div>
//       {error && (
//         <Alert severity="error" sx={{ mb: 2 }}>
//           {error}
//         </Alert>
//       )}
//       {success && (
//         <Alert severity="success" sx={{ mb: 2 }}>
//           {success}
//         </Alert>
//       )}
//       <FormControl fullWidth sx={{ mb: 2 }}>
//         <FormHelperText id="user-select-label">Select User</FormHelperText>
//         <Select
//           labelId="user-select-label"
//           value={selectedUser}
//           onChange={(e) => {
//             const user = users.find((u) => u.id === e.target.value);
//             setSelectedUser(user);
//           }}
//           disabled={loading}
//         >
//           {users.map((user) => (
//             <MenuItem key={user.id} value={user.id}>
//               {user.empName} ({user.empId})
//             </MenuItem>
//           ))}
//         </Select>
//       </FormControl>
//       <Button
//         variant="contained"
//         color="primary"
//         onClick={handleSubmit}
//         // disabled={loading || !selectedUser}
//         // startIcon={loading ? <CircularProgress size={20} /> : null}
//       >
//         {
//           // loading ?
//           // "Reassigning..." :
//           "Reassign"
//         }
//       </Button>
//     </div>
//   );
// }

// export default AlertDialogForm;

function AlertDialogForm({ request, setRefreshApi }) {
  const pdReassignUsers = [
    { id: 1, empName: "Prabhu Shanmugam(Electrical)", empId: "300420" },
    { id: 2, empName: "Prabhakaran K(Electrical)", empId: "300106" },
    // { id: 2, empName: "Sivaraj R(Bus Body)", empId: "300225" },
    { id: 3, empName: "Nandkumar Patil(Bus Body)", empId: "300669" },
    { id: 4, empName: "Govindaraj D(Battery)", empId: "300182" },
    // { id: 4, empName: "Karthik Babu Javvaji(Chassis)", empId: "300282" },
    { id: 5, empName: "Karthik VS(Chassis)", empId: "300321" },
    
    // { id: 5, empName: "Sivakumar Muthandi(Electrical)", empId: "300454" },
    
    // { id: 1, empName: "Karthick VS", empId: "300321" },
    // { id: 1, empName: "Sivakumar Muthandi", empId: "300454" },
  ];

  const sourcingReassignUsers = [
    { id: 1, empName: "Kuppu raj Rajagopal(Electrical)", empId: "300740" },
    { id: 2, empName: "Selva Sundaram(Battery)", empId: "300197" },
    // { id: 3, empName: "Vishal Maggon(Bus Body)", empId: "300680" },
    { id: 3, empName: "RAJARAM KULANTHAIVEL(Bus Body)", empId: "300639" },
    { id: 4, empName: "Prathivraj C(Chassis)", empId: "300088" },
  ];
  const currentEmpId = localStorage.getItem("empid");
  
const [users] = useState(() => {
  const selectedList = sourcingEmpIds.includes(currentEmpId)
    ? sourcingReassignUsers
    : pdReassignUsers;

  // 🔥 Remove the current employee from the list
  return selectedList.filter((u) => u.empId !== currentEmpId);
});

  const [selectedUser, setSelectedUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleSubmit = async () => {
    if (!selectedUser) {
      setError("Please select a user to reassign.");
      return;
    }

    setLoading(true);
    setError(null);
    setSuccess(null);

    const formData = new FormData();

    if (sourcingEmpIds.includes(currentEmpId)) {
      formData.append("il1_sourcing_assigned_id", selectedUser.empId);
      formData.append("il1_sourcing_assigned", selectedUser.empName);
    } else {
      formData.append("il1_pd_assigned_id", selectedUser.empId);
      formData.append("il1_pd_assigned", selectedUser.empName);
    }

    formData.append("ideaids", request?.id_x ?? "");
    try {
      const url = sourcingEmpIds.includes(currentEmpId)
        ? REASSIGNIL1SOURCING
        : REASSIGNIL1PD;

      await axios.post(VAVE + url, formData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      setSuccess("Submitted successfully!");
      setRefreshApi(true);
      setSelectedUser(null);
    } catch (error) {
      console.error("Upload failed:", error);
      setError("Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      {success && (
        <Alert severity="success" sx={{ mb: 2 }}>
          {success}
        </Alert>
      )}
      <FormControl fullWidth sx={{ mb: 2 }}>
        <FormHelperText id="user-select-label">Select User</FormHelperText>
        <Select
          labelId="user-select-label"
          value={selectedUser?.id || ""}
          onChange={(e) => {
            const user = users.find((u) => u.id === e.target.value);
            setSelectedUser(user);
          }}
          disabled={loading}
        >
          {users.map((user) => (
            <MenuItem key={user.id} value={user.id}>
              {user.empName} ({user.empId})
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Button
        variant="contained"
        color="primary"
        onClick={handleSubmit}
        disabled={loading || !selectedUser}
        startIcon={loading ? <CircularProgress size={20} /> : null}
      >
        {loading ? "Reassigning..." : "Reassign"}
      </Button>
    </div>
  );
}

export default AlertDialogForm;
